import React from 'react';
import PropTypes from 'prop-types';

import TmntText from '../tmnt-text/tmnt-text';

export default function ExchangeSummary({
  calculation,
  className = '',
  variant = '',
  totalOnly = false,
}) {
  const retItmCtCondition = calculation?.orderCalculation?.returnItemCount;
  const refSignCondition = retItmCtCondition > 0 ? '-' : null;
  return (
    <div className={`exchange-summary ${className} ${variant} ${totalOnly ? 'total-only' : ''}`}>
      <ul className="exchange-summary-list">
        {!totalOnly && (
          <>
            <li>
              <span>
                <TmntText k="DRE_REFUND_ITEMS" />
                <span className="spacer-left-two-px">
                  (
                  {calculation?.orderCalculation?.returnItemCount}
                  )
                </span>
              </span>
              <span className="summary-emphasis">
                {refSignCondition}
                <span dangerouslySetInnerHTML={{ __html: `${calculation?.orderCalculation?.itemsRefundFmt}` }} />
              </span>
            </li>
            <li>
              <span>
                <TmntText k="DRE_EXCHANGE_ITEMS" />
                <span className="spacer-left-two-px">
                  (
                  {calculation?.orderCalculation?.exchangeItemCount}
                  )
                </span>
              </span>
              <span dangerouslySetInnerHTML={{ __html: `${calculation?.orderCalculation?.exchangeAmountFmt}` }} />
            </li>
            <li>
              <TmntText k="DRE_TAX_TEXT" />
              <span className="summary-emphasis">
                {refSignCondition}
                <span dangerouslySetInnerHTML={{ __html: `${calculation?.orderCalculation?.salesTaxRefundFmt}` }} />
              </span>
            </li>
            <li>
              <TmntText k="DRE_RETURN_SHIPPING" />
              <span dangerouslySetInnerHTML={{ __html: `${calculation?.orderCalculation?.shippingChargesFmt}` }} />
            </li>
          </>
        )}
        <li className="final">
          <TmntText k="DRE_ESTIMATED_REFUND" className="estimated-refund-label" />
          <span>
            {refSignCondition}
            <span dangerouslySetInnerHTML={{ __html: `${calculation?.orderCalculation?.totalRefundFmt}` }} />
          </span>
        </li>
      </ul>
    </div>
  );
}

ExchangeSummary.propTypes = {
  calculation: PropTypes.shape({
    orderCalculation: PropTypes.shape({
      itemsRefundFmt: PropTypes.string,
      salesTaxRefundFmt: PropTypes.string,
      returnItemCount: PropTypes.string,
      exchangeItemCount: PropTypes.string,
      exchangeAmountFmt: PropTypes.string,
      shippingChargesFmt: PropTypes.string,
      totalRefundFmt: PropTypes.string,
    }),
  }),
  className: PropTypes.string,
  variant: PropTypes.string,
  totalOnly: PropTypes.bool,
};
